module.exports = __webpack_public_path__ + "open-sans-light.7c5d9f078bea8c1fc0b2.woff";


//////////////////
// WEBPACK FOOTER
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/assets/fonts/google/open-sans-light.woff
// module id = phbp
// module chunks = 1